import * as types from "../../constants/actionTypes";
import moment from 'moment';

const initState = {
    isLoading: false,
    masterData: [],
    listDokter: [],
    listICD: [],
    listRiwayatPenyakitPasien: [],
    stepDiagnosa: "0",
    currentStep: "0",
    formDokter: {
        f_id_dokter: "",
        f_kode_dokter: "",
        f_nama_dokter: "",
        f_tanggal_lahir: "",
        f_jenis_kelamin: "",
        f_email_dokter: "",
        f_password_dokter: "",
        f_telepon_dokter: "",
        f_no_alamat_dokter: "",
        f_catatan: "",
        f_id_negara: "100",
        temp_lokasi: [],
    },
    cariDokter: {
        findByCode: "",
        isExist: 0,
    },
    formDokterPraktek: {
        f_id_poli: "",
    },
    formJadwalPraktek: {
        f_id_dokter_praktek: "",
        f_list_hari: ["1"],
        f_jadwal_praktek: [],
    },
    countJadwalPraktek: {
        countJP_0: [
            {
                index: 0,
            }
        ],
        countJP_1: [
            {
                index: 0,
            },
        ]
        ,
        countJP_2: [
            {
                index: 0,
            }
        ],
        countJP_3: [
            {
                index: 0,
            }
        ],
        countJP_4: [
            {
                index: 0,
            }
        ],
        countJP_5: [
            {
                index: 0,
            }
        ],
        countJP_6: [
            {
                index: 0,
            }
        ],
    },
    currentRekamMedis: {
        f_id_pasien : ""
    },
    dropdownListLayanan: [],
    dataListLayanan:[],
    modalListLayanan: {
        modalVisible: false,
        modalLoading: false,
        f_id_layanan: null,
        f_tarif_layanan: '-',
        status_administrasi: '',
        f_tarif_administrasi: '-',
    },
    dropdownLisObat: [],
    dataListObat:[],
    modalListObat: {
        modalVisible: false,
        modalLoading: false,
        f_id_obat: null,
        f_dosis_obat: '',
        f_jmlh_obat: '',
    },
    formDiagnosaStep1: {},
    formDiagnosaStep2: {
        f_berat_badan: "",
        f_tinggi_badan: "",
        f_suhu_tubuh: "",
        f_frekuensi_nafas: "",
        f_nadi: "",
        f_tekanan_darah_sistole: "",
        f_tekanan_darah_diastole: "",
        f_keluhan_pasien: "",
    },
    formDiagnosaStep3: {
        f_id_icd: "",
        f_diagnosa: "",
    },
    formDiagnosaStep4: {},


};

export default function (state = initState, action) {
    switch (action.type) {
        
        case types.MODULE_DOKTER_SET_LOADER: {
            return{
                ...state,
                isLoading: action.value
            }
        }
        case types.MODULE_DOKTER_DATA_GET_ALL_SUCCESS: {
            return{
                ...state,
                listDokter: action.value
            }
        }
        case types.MODULE_DOKTER_DATA_GET_DETAIL_SUCCESS: {
            return{
                ...state,
                formDokter: {
                    ...action.payload,
                }
            }
        }
        case types.MODULE_DOKTER_RIWAYAT_PENYAKIT_PASIEN_SUCCESS: {
            return{
                ...state,
                listRiwayatPenyakitPasien: action.payload
            }
        }
        case types.MODULE_DOKTER_VALIDATE_CODE_SUCCESS: {
            return{
                ...state,
                formDokterPraktek: {
                    ...state.formDokterPraktek,
                    ...action.payload,
                }
            }
        }
        case types.MODULE_DOKTER_MASTER_DATA_SUCCESS: {
            return{
                ...state,
                masterData: {
                    ...state.masterData,
                    [action.property] : action.value
                }
            }
        }
        case types.MODULE_DOKTER_DATA_GET_LIST_DOKTER_PRAKTEK_SUCCESS: {
            return{
                ...state,
                listDokterPraktek: action.value
            }
        }
        case types.MODULE_DOKTER_INIT_FORM_DOKTER: {
            return {
                ...state,
                formDokter: {
                    ...initState.formDokter
                }
            }
        }
        case types.MODULE_DOKTER_INIT_FORM_CARI_DOKTER: {
            return {
                ...state,
                cariDokter: {
                    ...initState.cariDokter
                }
            }
        }
        case types.MODULE_DOKTER_INIT_FORM_JADWAL_PRAKTEK: {
            return {
                ...state,
                formJadwalPraktek: {
                    ...initState.formJadwalPraktek
                }
            }
        }
        case types.MODULE_DOKTER_HANDLE_STATE_FORM: {
            return {
                ...state,
                formDokter: {
                    ...state.formDokter,
                    [action.property]: action.value,
                }
            }
        }
        case types.MODULE_DOKTER_HANDLE_STATE_CARI_DOKTER: {
            return {
                ...state,
                cariDokter: {
                    ...state.cariDokter,
                    [action.property]: action.value,
                }
            }
        }
        case types.MODULE_DOKTER_HANDLE_STATE_DOKTER_PRAKTEK: {
            return {
                ...state,
                formDokterPraktek: {
                    ...state.formDokterPraktek,
                    [action.property]: action.value,
                }
            }
        }
        case types.MODULE_DOKTER_HANDLE_STATE_JADWAL_PRAKTEK: {
            return {
                ...state,
                formJadwalPraktek: {
                    ...state.formJadwalPraktek,
                    [action.property]: action.value,
                }
            }
        }
        case types.MODULE_DOKTER_HANDLE_STATE_JADWAL_PRAKTEK2: {
            return {
                ...state,
                formJadwalPraktek: {
                    ...state.formJadwalPraktek,
                    f_jadwal_praktek: {
                        ...state.formJadwalPraktek.f_jadwal_praktek,
                        [action.property] : action.value
                    },
                }
            }
        }
        case types.MODULE_DOKTER_HANDLE_STATE_OUTER: {
            return {
                ...state,
                [action.property]: action.value
            }
        }
        case types.MODULE_DOKTER_HANDLE_ADD_JADWAL: {
            return {
                ...state,
                countJadwalPraktek: {
                    ...state.countJadwalPraktek,
                    [action.hari] : action.value
                }
            }
        }

        // diagnosa 
        // layanan
        case types.MODULE_DOKTER_DROPDOWN_LAYANAN_GET_SUCCESS: {
            return{
                ...state,
                dropdownListLayanan: action.value
            }
        }
        case types.MODULE_DOKTER_HANDLE_STATE_FORM_MODAL_LAYANAN: {
            return {
                ...state,
                modalListLayanan: {
                    ...state.modalListLayanan,
                    [action.property]: action.value,
                }
            }
        }
        case types.MODULE_DOKTER_LISTDATA_LAYANAN_GET_SUCCESS: {
            return {
                ...state,
                modalListLayanan: {
                    ...state.modalListLayanan,
                    ...action.value
                }
            }
        }
        case types.MODULE_DOKTER_HANDLE_ADD_LAYANAN_TO_LIST_SUCCESS: {
            return {
                ...state,
                dataListLayanan: action.value,
                modalListLayanan: initState.modalListLayanan
            }
        }

        // obat
        case types.MODULE_DOKTER_DROPDOWN_OBAT_GET_SUCCESS: {
            return{
                ...state,
                dropdownListObat: action.value
            }
        }
        case types.MODULE_DOKTER_HANDLE_STATE_FORM_MODAL_OBAT: {
            return {
                ...state,
                modalListObat: {
                    ...state.modalListObat,
                    [action.property]: action.value,
                }
            }
        }
        case types.MODULE_DOKTER_LISTDATA_OBAT_GET_SUCCESS: {
            return {
                ...state,
                modalListObat: {
                    ...state.modalListObat,
                    ...action.value
                }
            }
        }
        case types.MODULE_DOKTER_HANDLE_ADD_OBAT_TO_LIST_SUCCESS: {
            return {
                ...state,
                dataListObat: action.value,
                modalListObat: initState.modalListObat
            }
        }
        case types.MODULE_DOKTER_DROPDOWN_ICD_GET_SUCCESS: {
            return {
                ...state,
                listICD: action.value
            }
        }
        //form diagnosa
        case types.MODULE_DOKTER_CHECK_STATUS_DIAGNOSA_SUCCESS: {
            return {
                ...state,
                stepDiagnosa: action.value,
                currentStep: action.value,
                currentRekamMedis: action.data
            }
        }

        case types.MODULE_DOKTER_HANDLE_STATE_DIAGNOSA1_SUCCESS: {
            return {
                ...state,
                formDiagnosaStep1: action.value
            }
        }
        case types.MODULE_DOKTER_INIT_FORM_DIAGNOSA1: {
            return {
                ...state,
                formDiagnosaStep1: initState.formDiagnosaStep1
            }
        }
        case types.MODULE_DOKTER_INIT_FORM_DIAGNOSA2: {
            return {
                ...state,
                formDiagnosaStep2: action.value
            }
        }
        case types.MODULE_DOKTER_INIT_FORM_DIAGNOSA3: {
            return {
                ...state,
                formDiagnosaStep3: action.value
            }
        }
        case types.MODULE_DOKTER_INIT_FORM_DIAGNOSA4: {
            return {
                ...state,
                formDiagnosaStep4: action.value
            }
        }
        case types.MODULE_DOKTER_HANDLE_STATE_DIAGNOSA2: {
            return {
                ...state,
                formDiagnosaStep2: {
                    ...state.formDiagnosaStep2,
                    [action.property]: action.value,
                }
            }
        }
        case types.MODULE_DOKTER_TO_DIAGNOSA2_SUCCESS: {
            return {
                ...state,
                formDiagnosaStep2: action.value
            }
        }
        case types.MODULE_DOKTER_TO_DIAGNOSA3_SUCCESS: {
            return {
                ...state,
                formDiagnosaStep3: action.valueformDiagnosaStep3,
                dataListObat: action.valuedataListObat,
                dataListLayanan: action.valuedataListLayanan
            }
        }
        case types.MODULE_DOKTER_HANDLE_STATE_DIAGNOSA3: {
            return {
                ...state,
                formDiagnosaStep3: {
                    ...state.formDiagnosaStep3,
                    [action.property]: action.value,
                }
            }
        }
        default:
            return {
                ...state
            }
    }
}  